import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserCheck, Check, X } from "lucide-react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { EmptyState } from "../../components/Common";
import { ADMIN_MENU } from "../../lib/menus";
import { formatDate } from "../../lib/format";
import api from "../../lib/api";

export default function MemberApprovals() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/members?status=PENDING&limit=100").then((r) => setRows(r.data.items)).catch(() => setRows([]));
  useEffect(() => { document.title = "Persetujuan Member - DS KODE"; load(); }, []);

  const act = async (id, s) => {
    try { await api.put(`/admin/members/${id}/status`, { status: s }); toast.success(s === "APPROVED" ? "Member disetujui" : "Member ditolak"); load(); } catch { toast.error("Gagal"); }
  };

  return (
    <DashboardLayout title="Persetujuan Member" menu={ADMIN_MENU} testid="member-approvals">
      <p className="text-sm text-slate-500 mb-5">Member baru dengan status menunggu persetujuan.</p>
      {rows === null ? <div className="h-64 skeleton rounded-xl" /> : rows.length === 0 ? <EmptyState icon={UserCheck} title="Tidak ada member menunggu persetujuan." subtitle="Semua pendaftaran telah diproses." /> : (
        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[700px]">
              <thead className="bg-slate-50 border-b border-slate-200"><tr><th className="th">No</th><th className="th">Nama</th><th className="th">Username</th><th className="th">Email</th><th className="th">WhatsApp</th><th className="th">Tgl Daftar</th><th className="th text-right">Aksi</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {rows.map((m, i) => (
                  <tr key={m.id} data-testid={`approval-row-${m.id}`}>
                    <td className="td">{i + 1}</td>
                    <td className="td font-medium text-slate-900">{m.name}</td>
                    <td className="td">@{m.username}</td>
                    <td className="td text-slate-500">{m.email}</td>
                    <td className="td text-slate-500">{m.whatsapp || "-"}</td>
                    <td className="td text-slate-500">{formatDate(m.created_at)}</td>
                    <td className="td">
                      <div className="flex justify-end gap-2">
                        <button onClick={() => act(m.id, "APPROVED")} data-testid={`admin-approve-member-btn-${m.id}`} className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700"><Check className="h-3.5 w-3.5" /> Setujui</button>
                        <button onClick={() => act(m.id, "REJECTED")} data-testid={`admin-reject-member-btn-${m.id}`} className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-lg border border-red-200 text-red-600 hover:bg-red-50"><X className="h-3.5 w-3.5" /> Tolak</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
